import {AppActions, useAppContext} from "../../Context/ProjectContextV2";
import {useEffect, useState} from "react";
import {Button, notification, Tabs, Tag, Tooltip, Typography} from "antd";
import HecRasProject from "../HecRasProject";
import {CloseOutlined} from "@ant-design/icons";
import ApiService from "../../Service/ApiService";
import JSZip from "jszip";


const ProjectTab = ({project, onProjectChanged, onSaveProject}) => {
    return (
        <HecRasProject
            project={project}
            onProjectChanged={onProjectChanged}
            onSaveProject={onSaveProject}
        />
    )
}

const compressJsonBase64 = async (json) => {
    const zip = new JSZip();
    zip.file('data.json', JSON.stringify(json));
    return await zip.generateAsync({ type: 'base64', compression: 'DEFLATE', compressionOptions: {level: 9} });
}

export default function ProjectList() {
    const {appContext, dispatchProject} = useAppContext()
    const [tab, setTab] = useState(null)

    useEffect(() => {
        if(!tab && appContext?.projects?.length > 0) {
            setTab(appContext?.projects[0]?.information?.id)
        }
    }, [appContext?.projects?.length]);

    const onProjectChanged = (project) => {
        dispatchProject({
            type: AppActions.SET_PROJECT,
            data: {
                project: {
                    ...project
                }
            }
        })
    }

    const onSaveProject = async (project) => {
        const input = {
            title: project?.information?.title?.trim(),
            description: project?.information?.descriptions || [],
            planCount: project?.projectFiles?.length,
            projectState: await compressJsonBase64(project),
            key: project?.key,
            notes: project?.notes,
            hecrasVersion: project?.version
        }

        const res = await ApiService.UserProject.SaveProject(input)
        if(res.success) {
            notification.success({
                message: 'Project was saved successfully',
                placement: 'bottomRight',
            })
        }
    }

    const onRemoved = (projectId) => {
        const index = appContext?.projects?.findIndex(x => x?.information?.id === projectId)
        if(index > 0) {
            setTab(appContext?.projects[index-1]?.information?.id)
        }

        dispatchProject({
            type: AppActions.REMOVE_PROJECT,
            data: {id: projectId}
        })
    }

    useEffect(() => {
        if(appContext?.projects?.length === 1) {
            setTab(appContext?.projects[0]?.information?.id)
        }
    }, [appContext?.projects?.length]);

    const renderTabs = () => {
        return appContext?.projects?.map(x => ({
            label: (
                <table key={x?.information?.id}>
                    <tbody>
                    <tr>
                        <td style={{minWidth: 300, textAlign: 'start'}}>
                            <b>{x?.information?.folderName}</b>
                        </td>
                        <td>
                            <Tag>{x?.modelType}</Tag>
                        </td>
                        <td>
                            <Button
                                style={{width: 32}}
                                size={'small'}
                                type={'text'}
                                icon={<CloseOutlined style={{marginRight: 0}}/>}
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    onRemoved(x?.information?.id)
                                }}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            ),
            key: x?.information?.id,
            children: (
                <div key={x?.information?.projectHash}>
                    <ProjectTab
                        project={x}
                        onSaveProject={onSaveProject}
                        onRemoved={onRemoved}
                        onProjectChanged={onProjectChanged}
                    />
                </div>
            )
        }))
    }

    return (
        <Tabs
            type={'card'}
            tabPosition={'left'}
            onChange={(tab) => {
                setTab(tab)
            }}
            activeKey={tab}
            items={renderTabs() || []}
        />
    )
}